import { LitElement, html, css } from 'lit';

class CheckSectionTitle extends LitElement {
  static properties = {
    label: { type: String },
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.label = '';
  }
  static styles = css`
    .check-section-title {
      display: flex;
      gap: 8px;
      background-color: #FFF;
      align-items: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
    }
  `
  render() {
    return html`
      <div class="check-section-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none" style="color: white;">
          <path d="M1.75 3.83577L6.95833 9.04411L14.25 1.75244" stroke="#D76315" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>${this.label}</div>
      </div>
    `;
  }
}
if (!customElements.get('check-section-title'))
customElements.define('check-section-title', CheckSectionTitle);
